// @flow
import React, { Component } from "react";

type PropsType = {
  translate: string => void
};

type StateType = {};

class FeaturesUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <section className="section">
        <div className="container">
          <header className="section-header">
            <small>{translate("LandingPageLocale.features_unit.small_header")}</small>
            <h2>{translate("LandingPageLocale.features_unit.main_header")}</h2>
            <hr />
            <p className="lead">{translate("LandingPageLocale.features_unit.main_content")}</p>
          </header>

          <div className="row gap-y">
            <div className="w-100" />

            <div className="col-md-6 col-xl-4">
              <div className="media">
                <div className="lead-6 line-height-1 text-lighter w-70px">
                  <i className="fas fa-code" />
                </div>
                <div className="media-body">
                  <h5>{translate("LandingPageLocale.features_unit.features.technology.header")}</h5>
                  <p>{translate("LandingPageLocale.features_unit.features.technology.content")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-4">
              <div className="media">
                <div className="lead-6 line-height-1 text-lighter w-70px">
                  <i className="fas fa-laptop" />
                </div>
                <div className="media-body">
                  <h5>{translate("LandingPageLocale.features_unit.features.platform.header")}</h5>
                  <p>{translate("LandingPageLocale.features_unit.features.platform.content")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-4">
              <div className="media">
                <div className="lead-6 line-height-1 text-lighter w-70px">
                  <i className="fas fa-globe" />
                </div>
                <div className="media-body">
                  <h5>{translate("LandingPageLocale.features_unit.features.online.header")}</h5>
                  <p>{translate("LandingPageLocale.features_unit.features.online.content")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-4">
              <div className="media">
                <div className="lead-6 line-height-1 text-lighter w-70px">
                  <i className="fas fa-coins" />
                </div>
                <div className="media-body">
                  <h5>{translate("LandingPageLocale.features_unit.features.modular.header")}</h5>
                  <p>{translate("LandingPageLocale.features_unit.features.modular.content")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-4">
              <div className="media">
                <div className="lead-6 line-height-1 text-lighter w-70px">
                  <i className="fas fa-file-alt" />
                </div>
                <div className="media-body">
                  <h5>{translate("LandingPageLocale.features_unit.features.reports.header")}</h5>
                  <p>{translate("LandingPageLocale.features_unit.features.reports.content")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-4">
              <div className="media">
                <div className="lead-6 line-height-1 text-lighter w-70px">
                  <i className="fas fa-support" />
                </div>
                <div className="media-body">
                <h5>{translate("LandingPageLocale.features_unit.features.support.header")}</h5>
                  <p>{translate("LandingPageLocale.features_unit.features.support.content")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FeaturesUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/LandingPage/FeaturesUnit.js